import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { listOfDay } from '../../../store/entities';
import { getCurrentDay } from '../../../utils';

@Component({
  selector: 'mwo-day-selector',
  templateUrl: './day-selector.component.html',
  styleUrls: ['./day-selector.component.scss']
})
export class DaySelectorComponent implements OnInit {
  @Input() playlistMode = false;
  @Input() activeDay: string;
  @Input() justifyContentPosition: string = 'center';
  @Output() daySelected: EventEmitter<string> = new EventEmitter<string>();

  readonly days: string[] = listOfDay;
  readonly today: string = getCurrentDay();

  constructor() { }

  ngOnInit() {
  }
}
